import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./slices/counterSlice";
import andReducer from "./slices/andArenaSlice";
import artistReducer from "./slices/artistProfileSlice";
import artistsReducer from "./slices/artistSlice";
import bookingReducer from "./slices/bookingSlice";
import packageReducer from "./slices/packageSlice";
import loginReducer from "./slices/loginSlice";
import jobReducer from "./slices/jobPostingSlice";
import adminReducer from "./slices/adminSlice";

export const store = configureStore({
  reducer: {
    counterReducer: counterReducer,
    andArena: andReducer,
    artistProfile: artistReducer,
    artists: artistsReducer,
    booking: bookingReducer,
    package: packageReducer,
    login: loginReducer,
    job: jobReducer,
    admin: adminReducer,
  },
});
